import React from 'react';
import { PageTitle, Informacao } from '~/components';
import { AA_TEXT_PRIMARY_ON_LIGHT } from '~/modules/Helper/contrast.helper';

const dadosHeadingStyle = {
  margin: '0 0 12px',
  fontSize: 16,
  fontWeight: 600,
  lineHeight: 1.3,
  color: AA_TEXT_PRIMARY_ON_LIGHT,
};

function Header({ configuracao }) {
  const temInformacao = Boolean(configuracao?.Informacao?.Texto);

  return (
    <>
      {configuracao?.Titulo && <PageTitle titulo={configuracao.Titulo} />}

      {temInformacao ? (
        <Informacao
          titulo={configuracao.Informacao.Titulo}
          informacao={configuracao.Informacao.Texto}
        />
      ) : (
        configuracao?.Titulo && (
          <h2 style={dadosHeadingStyle}>Dados da visão</h2>
        )
      )}
    </>
  );
}

export default Header;
